import moment from "moment";
import { useTranslation } from "react-i18next";

import { useInvoices } from "context/client/invoices";

import Table from "components/Table";
import PlanTag from "../PlanTag";
import InvoiceFilters from "../InvoiceFilters";

import priceRender from "libs/helpers/priceRender";

const InvoicesTable = () => {
  const { t } = useTranslation();
  const { data, loading, filters, filterHandler, clearAllFilter, showInvoice } =
    useInvoices();
  const filtersCount = ["website", "start_date", "end_date"].filter(
    (name) => !!filters[name],
  ).length;

  const table_data = {
    keys: [
      { key: "website", value: t("Website") },
      { key: "created_at", value: t("Payment date") },
      {
        sort_key: "price_id",
        key: "subscription_plan",
        value: t("Subscription plan"),
      },
      { key: "amount", value: t("Amount") },
      { key: "invoice", sort_key: false, value: t("Invoice") },
    ],
    items: data?.map(
      ({
        name,
        website,
        website_id,
        created_at,
        amount,
        currency,
        invoice_id,
      }) => [
        {
          key: "website",
          type: "link",
          value: { label: website, href: `/websites/${website_id}/` },
        },
        { key: "created_at", value: moment(created_at)?.format("ll") },
        { key: "subscription_plan", value: <PlanTag name={name} /> },
        {
          key: "amount",
          value: priceRender((amount / 100)?.toFixed(2), currency),
        },
        {
          key: "invoice",
          type: "clickable_text",
          value: {
            label: t("Download"),
            icon: "view",
            onclick: () => showInvoice(invoice_id),
          },
        },
      ],
    ),
  };

  return (
    <Table
      data={table_data}
      loading={!!loading}
      sort={filters?.sort}
      setSort={(value) => filterHandler("sort", value)}
      filters_count={filtersCount}
      filter_default_open={filtersCount > 0}
      filters_always_show={true}
      filterClearAll={clearAllFilter}
      filters={<InvoiceFilters values={filters} onChange={filterHandler} />}
    />
  );
};

export default InvoicesTable;
